// extracted by mini-css-extract-plugin
export default {"classes_view_tabs":"classes-view-tabs_classes_view_tabs__ocvZ0"};